import React, { createContext, useContext, useState } from 'react';

interface ModalContextType {
  isPitchDeckTipsOpen: boolean;
  openPitchDeckTips: () => void;
  closePitchDeckTips: () => void;
  isIntakeFormOpen: boolean;
  openIntakeForm: () => void;
  closeIntakeForm: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isPitchDeckTipsOpen, setIsPitchDeckTipsOpen] = useState(false);
  const [isIntakeFormOpen, setIsIntakeFormOpen] = useState(false);

  const openPitchDeckTips = () => {
    setIsPitchDeckTipsOpen(true);
  };
  
  const closePitchDeckTips = () => {
    setIsPitchDeckTipsOpen(false);
  };

  const openIntakeForm = () => {
    setIsIntakeFormOpen(true);
  };

  const closeIntakeForm = () => {
    setIsIntakeFormOpen(false);
  };

  return (
    <ModalContext.Provider value={{ 
      isPitchDeckTipsOpen, 
      openPitchDeckTips, 
      closePitchDeckTips,
      isIntakeFormOpen,
      openIntakeForm,
      closeIntakeForm
    }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
}; 